<template>
    <div class="cashier-deposit">

        <div class="deposit-section">

            <CashierElement v-on:click.native="modalCryptoButton('btc')" type="btc" method="crypto" v-bind:enabled="true" />
            <CashierElement v-on:click.native="modalCryptoButton('ltc')" type="ltc" method="crypto" v-bind:enabled="true" />
            <CashierElement v-on:click.native="modalCryptoButton('eth')" type="eth" method="crypto" v-bind:enabled="true" />
        </div>

        <div class="deposit-section">
            <div class="section-gift">
                <div class="gift-title">Redeem Bonus Code</div>
                <div class="gift-input">
                    <input v-model="modalGiftCode" type="text" placeholder="XXXX-XXXX-XXXX-XXXX" />
                    <button v-on:click="modalRedeemButton()" class="button-redeem" v-bind:disabled="socketSendLoading !== null">
                        <div class="button-inner">REDEEM</div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import CashierElement from '@/components/cashier/CashierElement';

    export default {
        name: 'CashierDeposit',
        components: {
            CashierElement
        },
        data() {
            return {
                modalGiftCode: null
            }
        },
        methods: {
            ...mapActions([
                'notificationShow',
                'modalsSetShow', 
                'modalsSetData'
            ]),
            modalCreditButton() {
                this.modalsSetShow(null);
                this.modalsSetData({ typeCashier: 'deposit' });

                setTimeout(() => { this.modalsSetShow('Credit'); }, 200);
            },
            modalCryptoButton(currency) {
                // This triggers the CashierCryptoDeposit.vue component we updated earlier
                this.modalsSetShow(null);
                this.modalsSetData({ typeCashier: 'deposit', currency: currency });

                // Ensure this matches the name defined in your ModalCashier.vue router/switch
                setTimeout(() => { this.modalsSetShow('Crypto'); }, 200);
            },
            modalRedeemButton() {
                if(this.modalGiftCode === null || this.modalGiftCode.trim() === '') {
                    this.notificationShow({ type: 'error', message: 'Your entered gift code is invalid.' });
                    return;
                }

                this.modalsSetShow(null);

                setTimeout(() => {
                    this.modalsSetData({ typeCaptcha: 'giftRedeem', data: { code: this.modalGiftCode.replaceAll('-', '') } });
                    this.modalsSetShow('Captcha');
                }, 200);
            }
        },
        computed: {
            ...mapGetters([
                'generalSettings',
                'socketSendLoading'
            ])
        }
    }
</script>

<style scoped>
    .cashier-deposit {
        width: 100%;
    }

    .cashier-deposit .deposit-section {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 15px;
    }

    .cashier-deposit .section-gift {
        width: calc(50% - 18px);
        margin-left: 12px;
    }

    .cashier-deposit .gift-title {
        font-size: 13px;
        font-weight: 400;
        color: #5191b1;
    }

    .cashier-deposit .gift-input {
        width: 100%;
        height: 64px;
        position: relative;
        margin-top: 7px;
    }

    .cashier-deposit .gift-input input {
        width: 100%;
        height: 100%;
        padding: 0 115px 0 20px;
        border-radius: 12px;
        font-size: 13px;
        font-weight: 400;
        color: #ffffff;
        background: #072131;
        border: 1px dashed #123651;
    }

    .cashier-deposit .gift-input input::placeholder {
        color: #bbbfd0;
    }

    .cashier-deposit button.button-redeem {
        width: 95px;
        height: 36px;
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translate(0, -50%);
        transition: all .2s;
        background: transparent;
        border: none;
        cursor: pointer;
    }

    .button-redeem:hover {
        opacity: .8;
    }
    
    .button-redeem:active {
        scale: .9;
    }

    .cashier-deposit button.button-redeem .button-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-weight: 800;
        color: #ffffff;
        background: linear-gradient(255deg, #00ffc2 0%, #00aa6d 100%);
        clip-path: polygon(5px 0, calc(100% - 5px) 0, 100% 25%, 100% 75%, calc(100% - 5px) 100%, 5px 100%, 0 75%, 0 25%);
    }

    @media only screen and (max-width: 840px) {
        .cashier-deposit .section-gift {
            width: 100%;
            margin-top: 12px;
            margin-left: 0;
        }
    }
</style>